// extracted by mini-css-extract-plugin
export default {"pelicula":"Pelicula_pelicula__Z6L9o","movieImage":"Pelicula_movieImage__IDO91"};